<template>
  <div>
    <i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>
    <section v-if="!loading" class="forms">
      <div class="page-header">
        <h3 class="page-title">
          {{ location.name }}
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'locations' }">Einrichtungen</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Detail</li>
          </ol>
        </nav>
      </div>
      <div class="row">
        <div class="col-md-4 stretch-card grid-margin">
          <div class="card bg-gradient-danger card-img-holder text-white">
            <div class="card-body">
              <h4 class="font-weight-normal mb-3">
                Kinder <i class="mdi mdi-human-child mdi-24px float-right"></i>
              </h4>
              <h2 class="">{{ childs_count }}</h2>
              <h6 class="card-text"></h6>
            </div>
          </div>
        </div>
        <div class="col-md-4 stretch-card grid-margin">
          <div class="card bg-gradient-info card-img-holder text-white">
            <div class="card-body">
              <h4 class="font-weight-normal mb-3">
                Mitarbeiter
                <i class="mdi mdi-clipboard-account-outline mdi-24px float-right"></i>
              </h4>
              <h2 class="">{{ staff_count }}</h2>
              <h6 class="card-text"></h6>
            </div>
          </div>
        </div>
        <div class="col-md-4 stretch-card grid-margin">
          <div class="card bg-gradient-success card-img-holder text-white">
            <div class="card-body">
              <h4 class="font-weight-normal mb-3">
                App Nutzer
                <i class="mdi mdi-cellphone-text mdi-24px float-right"></i>
              </h4>
              <h2 class="">{{ users_count }}</h2>
              <h6 class="card-text"></h6>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 stretch-card grid-margin">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title"></h4>
              <b-tabs>
                <b-tab title="Account" active>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Stammdaten</h4>
                      <p class="card-description"></p>
                      <form class="forms-sample">
                        <b-form-group label="Kindy ID" label-for="input4">
                          <b-form-input readonly="" v-model="location.kindy_id" type="text" id="input4"
                            placeholder="Kindy ID"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Subdomain" label-for="input6">
                          <b-form-input readonly="" v-model="location.subdomain" type="text" id="input6"
                            placeholder="Subdomain"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Nächste Abrechnung" label-for="input115"
                          v-if="location.account_state == 'customer'">
                          <b-form-input readonly="" v-model="location_base.next_settlement" type="text" id="inputC1"
                            placeholder="Name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Name" label-for="inputC1">
                          <b-form-input readonly="" v-model="location_base.firstname" type="text" id="inputC1"
                            placeholder="Name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Nachname" label-for="inputC2">
                          <b-form-input readonly="" v-model="location_base.lastname" type="text" id="inputC2"
                            placeholder="Nachname"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Einrichtung" label-for="inputC3">
                          <b-form-input readonly="" v-model="location_base.name" type="text" id="inputC3"
                            placeholder="Einrichtung"></b-form-input>
                        </b-form-group>
                        <b-form-group label="E-Mail" label-for="inputC7">
                          <b-form-input readonly="" v-model="location_base.email" type="text" id="inputC7"
                            placeholder="E-Mail"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Straße" label-for="inputC4">
                          <b-form-input readonly="" v-model="location_base.street" type="text" id="inputC4"
                            placeholder="Straße"></b-form-input>
                        </b-form-group>
                        <b-form-group label="PLZ" label-for="inputC5">
                          <b-form-input readonly="" v-model="location_base.zip" type="text" id="inputC5"
                            placeholder="PLZ"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Ort" label-for="inputC6">
                          <b-form-input readonly="" v-model="location_base.city" type="text" id="inputC6"
                            placeholder="Ort"></b-form-input>
                        </b-form-group>
                      </form>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Mitarbeiter Accounts">
                  <table class="table">
                    <tr v-for="item in staff_list" :key="item.uid">
                      <td>
                        {{ item.firstname }}
                      </td>
                      <td>
                        {{ item.lastname }}
                      </td>
                      <td>
                        {{ item.access_type }}
                      </td>
                      <td>
                        {{ item.created_at }}
                      </td>
                      <td>
                        {{ item.email }}
                        <!--
                        <div v-if="location.kenc">
                          <a :href="'http://www.kindy.app/unmask-test-call?slot='+location.slot+'&str='+item.email">Unmask</a>
                        </div>
                        -->
                      </td>
                      <td>
                        {{ item.activated }}
                      </td>
                    </tr>
                  </table>
                </b-tab>
                <b-tab title="Produkte">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Bezeichnung</th>
                          <th>Preis</th>
                          <th>Anzahl</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in products" :key="item.uid">
                          <td>{{ item.name }}</td>
                          <td>{{ item.price }} Euro</td>
                          <td>{{ item.amout }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-tab>
                <b-tab title="Rechnungen">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Re-Nr.</th>
                          <th>Datum</th>
                          <th>Zeitraum</th>

                          <th>Gesamtbetrag</th>
                          <th>Zahlungseingang</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in billings" :key="item.uid">
                          <td>
                            <span>{{ item.invoice_nr }}</span>
                          </td>
                          <td>{{ item.invoice_date }}</td>
                          <td>
                            {{ item.invoice_range_from }} -
                            {{ item.invoice_range_to }}
                          </td>

                          <td>
                            {{ (item.invoice_amount / 100) | toCurrency }}
                          </td>
                          <td>
                            <div v-if="item.paid">
                              <i class="fa fa-check" aria-hidden="true"></i>
                              {{ item.paid_at }}
                            </div>
                          </td>

                          <td style="text-align: right">
                            <!-- Modal starts -->
                            <div class="text-center">
                              <a v-if="item.download_file" :href="item.download_file" target="_blank">PDF
                                Herunterladen</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <b-modal id="modalmd" title="Details" size="md" ok-only @>
                      <form class="forms-sample">
                        <b-form-group label="Rechnung verschickt" label-for="emailsend">
                          <input type="checkbox" id="emailsend" name="emailsend" v-model="current_item.emailsend" />
                        </b-form-group>
                        <b-form-group label="" label-for="">
                          <date-picker v-model="current_item.emailsend_at" valueType="format" :format="dateFormat"
                            placeholder="Datum wählen"></date-picker>
                        </b-form-group>
                        <b-form-group label="Empfänger" label-for="input2">
                          <b-form-input type="text" id="input2" v-model="email_receiver"></b-form-input>
                        </b-form-group>

                        <div @click="sendInvoice()" class="btn btn-link">
                          Rechnung senden
                        </div>
                        <b-alert v-if="emailSend" variant="primary" style="margin-top: 20px" show>E-Mail gesendet ({{
                          emailStatus }})</b-alert>

                        <b-form-group label="Bezahlt" label-for="paid" style="margin-top: 30px">
                          <input type="checkbox" id="paid" name="paid" v-model="current_item.paid" />
                        </b-form-group>
                        <b-form-group label="" label-for="">
                          <date-picker v-model="current_item.paid_at" valueType="format" :format="dateFormat"
                            placeholder="Datum wählen"></date-picker>
                        </b-form-group>
                        <b-button variant="success" @click="saveEmailDetails()" class="mr-2">Speichern</b-button>
                        <b-alert v-if="modalSaved1" variant="primary" style="margin-top: 20px"
                          show>Gespeichert</b-alert>
                      </form>
                    </b-modal>
                    <!-- Modal Ends -->
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="js">

import Vue from 'vue';
import moment from 'moment';


import "vue2-dropzone/dist/vue2Dropzone.min.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';

// https://github.com/rowanwins/vue-dropzone

//let uuid = require("uuid");
import {
  getLocation,
  updateLocation,
  removeLocation,
  updateInvoiceInfo,
  sendInvoice,
  getLocationDocuments,
  addBilling,
  updateLocationBase
} from '@/services/locations.service';

export default {
  name: 'basicFormsElements',
  components: {
    DatePicker
  },
  data() {
    return {
      modalSaved1: false,
      emailStatus: null,
      emailSend: false,
      email_receiver: "",
      invoice_uid: null,
      current_item: {},
      file: null,
      location: {},
      products: [],
      childs_count: 0,
      users_count: 0,
      loading: true,
      staff_list: [],
      staff_count: 0,
      documents: [],
      invoices: [],
      billings: [],
      location_base: {},
      loading_account: false,
      loading_base: false,
      loading_remove: false,
      dateFormat: 'DD.MM.YYYY',
      options_state: [
        { value: null, text: '' },
        { value: 'test', text: 'Test' },
        { value: 'customer', text: 'Kunde' },
        { value: 'close', text: 'Geschlossen' },
        //{ value: 'd', text: 'This one is disabled', disabled: true }
      ],
      dropzoneOptions1: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'document' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
      dropzoneOptions2: {
        url: Vue.prototype.$apiBase + "/admin/locations/upload-document",
        //thumbnailWidth: 150,
        //thumbnailHeight: 150,
        headers: { "x-access-token": localStorage.getItem('token') },
        addRemoveLinks: false,
        params: { 'cat': 'invoice' },
        acceptedFiles: ".jpg, .jpeg, .png, .pdf",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag File or Click Here</p>
          `
      },
    }
  },
  computed: {
    document_list: function () {
      return this.$store.state.locations
    }
  },
  mounted() {

    this.loading = true

    getLocation(this.$route.params.uid).then((resp) => {

      if (resp.data.error) {
        if (resp.data.error == 'location') {
          this.$router.push({ name: 'locations' })
        }

        if (resp.data.error == 'user') {
          localStorage.removeItem('token')
          this.$router.push({ name: 'login' })
        }
      }
      else {

        this.location = resp.data.location

        if (this.location.created_at) {
          this.location.created_at = moment(this.location.created_at).format('DD.MM.YYYY');
        }

        this.dropzoneOptions1.params.loc_id = this.location.loc_id
        this.dropzoneOptions2.params.loc_id = this.location.loc_id

        this.dropzoneOptions1.params.location_uid = this.$route.params.uid
        this.dropzoneOptions2.params.location_uid = this.$route.params.uid

        this.location_base = resp.data.location_base
        this.childs_count = resp.data.childs_count
        this.staff_count = resp.data.staff_count
        this.users_count = resp.data.users_count

        this.billings = resp.data.billings


        this.products = resp.data.products

        this.$store.state.allProducts = resp.data.all_products

        this.invoices = resp.data.entries_invoices
        this.documents = resp.data.entries_documents

        this.$store.state.user_customer = resp.data.customer
        this.$store.state.user_company = resp.data.company

        this.staff_list = resp.data.staff_list

        this.loading = false

      }


    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });




  },
  methods: {
    saveEmailDetails: function () {
      console.log(this.current_item)

      updateInvoiceInfo({
        current_item: this.current_item,

      }).then((data) => {
        this.modalSaved1 = true


        if (data.data.billings) {
          this.billings = data.data.billings
        }
      })

    },
    sendInvoice: function () {
      console.log(this.email_receiver, this.current_item._id, this.current_item.location_uid)

      sendInvoice({
        email: this.email_receiver,
        id: this.current_item._id,
        location_uid: this.current_item.location_uid
      }).then((data) => {

        this.emailStatus = data.data.status

        this.emailSend = true



      })
    },
    openModal: function (item) {
      this.modalSaved1 = false

      this.email_receiver = this.location_base.email
      this.current_item = item
    },
    btnAddBilling: function (ev) {
      ev.preventDefault()

      addBilling({ location_uid: this.location.uid }).then((resp) => {
        console.log(resp)
        this.billings = resp.data.billings
      })
    },
    btnRemoveLocation: function (ev) {
      ev.preventDefault()


      this.$swal({
        title: '',
        text: "Soll dieser Account wirklich gelöscht werden?",
        showCancelButton: true,
        confirmButtonColor: '#30b3f6',
        cancelButtonColor: '#7F8FA4',
        cancelButtonText: 'Abbrechen',
        confirmButtonText: 'Ja, löschen.'
      }).then((result) => {
        if (result.value) {
          this.loading_remove = true
          removeLocation({ uid: this.location.uid }).then((resp) => {
            this.$store.state.locations = resp.data.locations
            Vue.$toast.open({
              message: 'Gelöscht',
              type: 'success',
              position: 'bottom',
              duration: 1500
            });

            this.$router.push({ name: 'locations', params: {} })
          })

        }
      })
    },

    openAccount: function () {
      window.open("https://" + this.location.subdomain + ".kindy.cloud?email=hallo", "_blank");
    },
    btnLocation: function (ev) {
      ev.preventDefault()
      this.loading_account = true
      updateLocation(this.location).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_account = false
      })
    },
    btnLocationBase: function (ev) {
      ev.preventDefault()

      this.location_base.location_uid = this.$route.params.uid

      if (this.location_base.next_settlement) {
        this.location_base.next_settlement_stamp = moment(this.location_base.next_settlement, "DD.MM.YYYY").format()
      }

      this.loading_base = true
      updateLocationBase(this.location_base).then(() => {
        Vue.$toast.open({
          message: 'Gespeichert',
          type: 'success',
          position: 'bottom',
          duration: 1500
        });
        this.loading_base = false
      })
    },
    async afterSuccess(file, response) {
      console.log(file, response.data.cat)

      getLocationDocuments({
        loc_id: this.location.loc_id,
        location_uid: this.$route.params.uid,
        cat: response.data.cat
      }).then((data) => {

        if (data.data.cat == 'document') {
          this.documents = data.data.entries
        }
        if (data.data.cat == 'invoice') {
          this.invoices = data.data.entries
        }

      })

    },
    async afterComplete(upload) {
      //var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        //let file = upload;
        //console.log(file)

        //var storageRef = firebase.storage().ref();
        //var imageRef = storageRef.child(`images/${imageName}.png`);
        //await imageRef.put(file, metadata);
        //var downloadURL = await imageRef.getDownloadURL();
        //this.images.push({ src: downloadURL });
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone1.removeFile(upload);
      this.$refs.imgDropZone2.removeFile(upload);
    }
  }
}
</script>


<style scoped>
.dropzone {
  margin-bottom: 50px;
  min-height: auto !important;
}
</style>